<template>
    <div class="ads-section">
        <div class="ads-section__header">
            <div class="ads-section__title">
                <span>Объявления</span>
            </div>
            <div class="ads-section__meta" v-if="ads && ads.length">
                <span class="ads-count">{{ ads.length }}</span>
                <span class="ads-label">объявлений</span>
            </div>
        </div>
        <div v-if="loading" class="ads-loading">
            <span class="ads-loading__text">Загрузка объявлений...</span>
        </div>
        <div v-else-if="error" class="ads-error">
            <span class="ads-error__text">{{ error }}</span>
        </div>
        <template v-else>
            <div v-if="ads && ads.length" class="ads-grid">
                <AdCard
                    v-for="ad in ads"
                    :key="ad.id"
                    :ad="ad"
                    :campaign-id="campaignId"
                    :normalize-status="normalizeStatus"
                    :status-label="statusLabel"
                    :format-period="formatPeriod"
                    :day-name="dayName"
                    :ms-to-h-m="msToHM"
                    :can-cancel-ad="canCancelAd"
                    :is-ad-cancelling-id="isAdCancellingId"
                    @cancel-click="$emit('cancel-click', $event)"
                    @preview-open="handlePreviewOpen"
                />
            </div>
            <div v-else class="ads-empty">
                <span class="ads-empty__text">Объявлений нет</span>
            </div>
        </template>
        <div
            v-if="previewItem"
            class="modal-backdrop"
            role="dialog"
            aria-modal="true"
            @click.self="closePreview"
        >
            <div class="modal" style="width: min(920px, 96vw)">
                <div class="modal__title">{{ previewItem.name }}</div>
                <div class="modal__body" style="display: flex; justify-content: center">
                    <img
                        v-if="isImage(previewItem.src)"
                        :src="previewItem.src"
                        :alt="previewItem.name"
                        style="max-width: 100%; max-height: 70vh; object-fit: contain"
                    />
                    <video
                        v-else
                        :src="previewItem.src"
                        controls
                        autoplay
                        style="max-width: 100%; max-height: 70vh; object-fit: contain"
                    ></video>
                </div>
                <div class="modal__actions">
                    <button class="btn" @click="closePreview">Закрыть</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdCard from './AdCard.vue';

export default {
    name: 'CampaignAds',
    components: {
        AdCard,
    },
    props: {
        campaignId: {
            type: [Number, String],
            required: true,
        },
        ads: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
        normalizeStatus: {
            type: Function,
            required: true,
        },
        statusLabel: {
            type: Function,
            required: true,
        },
        formatPeriod: {
            type: Function,
            required: true,
        },
        dayName: {
            type: Function,
            required: true,
        },
        msToHM: {
            type: Function,
            required: true,
        },
        canCancelAd: {
            type: Function,
            required: true,
        },
        isAdCancellingId: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            previewItem: null,
        };
    },
    methods: {
        handlePreviewOpen(previewData) {
            this.previewItem = previewData;
        },
        closePreview() {
            this.previewItem = null;
        },
        isImage(src) {
            if (!src || typeof src !== 'string') return false;
            return /\.(png|jpe?g|webp|gif|bmp|svg)(\?.*)?$/i.test(src);
        },
    },
};
</script>

<style scoped>
/* Основной контейнер объявлений */
.ads-section {
    margin-top: 8px;
    padding: 12px;
    background: var(--bg);
    border: 1px solid var(--card-border);
    border-radius: calc(var(--radius) - 4px);
    transition: all 0.2s ease;
}

/* Заголовок секции */
.ads-section__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.ads-section__title {
    font-size: 12px;
    font-weight: 600;
    color: var(--accent);
}

.ads-section__meta {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 6px;
    background: rgba(15, 23, 42, 0.05);
    border-radius: 4px;
    color: var(--muted);
    font-weight: 400;
    font-size: 10px;
}

.ads-count {
    font-size: 10px;
    font-weight: 600;
    color: var(--accent);
}

.ads-label {
    font-size: 10px;
    color: var(--muted);
}

/* Состояния загрузки и ошибки */
.ads-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #64748b;
}

.ads-error {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: linear-gradient(135deg, #fef2f2, #fee2e2);
    border: 1px solid #fecaca;
    border-radius: 12px;
    color: #dc2626;
}

.ads-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #64748b;
}

.ads-empty__text {
    font-size: 16px;
    font-weight: 500;
}

/* Сетка объявлений */
.ads-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 8px;
}

/* Адаптивность */
@media (max-width: 768px) {
    .ads-grid {
        grid-template-columns: 1fr;
    }
    
    .creatives-grid {
        grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    }
}
</style>


